import { render, staticRenderFns } from "./DetailSegment.vue?vue&type=template&id=9a71cf26&"
import script from "./DetailSegment.vue?vue&type=script&lang=js&"
export * from "./DetailSegment.vue?vue&type=script&lang=js&"
import style0 from "./DetailSegment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports